import React from "react";

import SearchIcon from "@mui/icons-material/Search";
import { Box, Typography } from "@mui/material";

const openGlobalSearch = () => {
  // GlobalSearchDialog (mounted app-wide) listens for this exact shortcut.
  window.dispatchEvent(
    new KeyboardEvent("keydown", { key: "k", metaKey: true }),
  );
};

/**
 * A clickable search bar in the top bar that opens the existing
 * GlobalSearchDialog by simulating the ⌘K shortcut it already listens for.
 */
const TopBarSearch = () => {
  return (
    <Box
      component="button"
      type="button"
      onClick={openGlobalSearch}
      aria-label="Open search (⌘K)"
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        flex: 1,
        maxWidth: 260,
        height: 36,
        px: 1.5,
        border: 1,
        borderColor: "divider",
        borderRadius: 1.5,
        bgcolor: "background.paper",
        color: "text.secondary",
        cursor: "pointer",
        font: "inherit",
        "&:hover": { bgcolor: "action.hover" },
      }}
    >
      <SearchIcon fontSize="small" />
      <Typography variant="body2" sx={{ flex: 1, textAlign: "left" }}>
        Search...
      </Typography>
      <Box
        component="kbd"
        sx={{
          fontSize: 11,
          px: 0.75,
          py: 0.25,
          borderRadius: "6px",
          bgcolor: "background.default",
          border: 1,
          borderColor: "divider",
        }}
      >
        ⌘K
      </Box>
    </Box>
  );
};

export default TopBarSearch;
